module.exports = __webpack_public_path__ + "static/media/gallery-3.468875d9.jpg";